import React, {Component} from 'react';
import { Route } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import {checkVersion} from 'modules/updateApp';

/** Route to render a route when user is authorized */
class SpogRoute extends Component {

    componentWillMount() {
        const {dispatch} = this.props;

        dispatch(checkVersion());
    }

    render() {
        return <Route {...this.props} />;
    }
}

export default injectIntl(connect()(SpogRoute));



// WEBPACK FOOTER //
// ./src/routes/SpogRoute.jsx